import { Routes } from '@angular/router';
import { DisplayPageComponent } from './pages/display-page/display-page.component';
import { TestDisplayComponent } from './pages/test-display/test-display.component';

export const routes: Routes = [
    {
        path: 'test-display',
        component: TestDisplayComponent
    },
    {
        path: 'parking-sites/:siteId/display/:displayId',
        component: DisplayPageComponent
    },
    { path: '**', redirectTo: '' }
];
